"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rfid_tag_types_1 = require("./rfid-tag.types");
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: rfid_tag_types_1.rfidTagConfigTypes.ON_MUTATION_CLICK, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: rfid_tag_types_1.rfidTagConfigTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
exports.default = { onCloseError, onClickMutation };
